export const calculateSrc = ({ desiredWidth, desiredHeight, url, quality, crop, offsetX, offsetY, fit = "width", }) => {
    const paramsObj = {
        auto: "webp",
        disable: "upscale",
    };
    const onlyWidth = !!desiredWidth && !desiredHeight;
    const onlyHeight = !!desiredHeight && !desiredWidth;
    const setWidthParam = () => {
        paramsObj.width = `${desiredWidth}`;
    };
    const setHeightParam = () => {
        paramsObj.height = `${desiredHeight}`;
    };
    const fitToHeightOrWidth = () => {
        if (fit === "height") {
            setHeightParam();
        }
        else if (desiredWidth) {
            setWidthParam();
        }
    };
    const cropImage = () => {
        setHeightParam();
        setWidthParam();
        const offsetCrop = [
            offsetX !== undefined && offsetX !== null ? `offset-x${offsetX}` : null,
            offsetY !== undefined && offsetY !== null ? `offset-y${offsetY}` : null,
        ]
            .filter((o) => o)
            .join(",");
        const offsetString = offsetCrop ? `,${offsetCrop}` : "";
        const cropString = `${desiredWidth}:${desiredHeight}${offsetString}`;
        paramsObj.crop = cropString;
    };
    if (quality) {
        paramsObj.quality = `${quality}`;
    }
    if (onlyWidth) {
        setWidthParam();
    }
    if (onlyHeight) {
        setHeightParam();
    }
    if (desiredWidth && desiredHeight) {
        if (crop) {
            cropImage();
        }
        else {
            fitToHeightOrWidth();
        }
    }
    const newSrc = new URL(`${url}?${new URLSearchParams([...Object.entries(paramsObj)])}`);
    return newSrc.toString();
};
//# sourceMappingURL=calculateSrc.js.map